import { FaRegListAlt } from 'react-icons/fa';
import { MdOutlineFileUpload } from 'react-icons/md';
import { Button } from '../../../../../../../components/button/button';
import { Checkbox } from '../../../../../../../components/checkbox/checkbox';
import { HasAccess, HasAccessProps } from '../../../../../../../features/has-access/has-access';
import { buildParams, concatPath } from '../../../../../../../helpers/path';
import {
  InformerPath,
  ManagerPath,
  MenuPath,
  RootPath,
} from '../../../../../../../routes/manager/manager-enums';
import { useManagerStore } from '../../../../../../../store/use-manager-store';
import { MenuInformerCreateCategoryModal } from './menu-informer-create-category-modal/menu-informer-create-category-modal';
import { MenuInformerCreateSectionsModal } from './menu-informer-create-section-modal/menu-informer-create-sections-modal';
import s from './menu-informer-table-header.module.css';
import { useMenuInformerTableHeader } from './use-menu-informer-table-header';

export const MenuInformerTableHeader = () => {
  const {
    dishCategoryModal,
    dishSectionModal,
    handlePutMenuStatus,
    navigate,
    menu,
    createDishModal,
    t,
    // menuSettingsModal,
  } = useMenuInformerTableHeader();
  const { hasAccess } = useManagerStore();
  const hasAccessProps: HasAccessProps = { service: 'menu', permissions: ['write'] };

  return (
    <div className={s.feature}>
      <Checkbox
        checked={menu?.is_on}
        onClick={handlePutMenuStatus}
        label={t('Активность меню')}
        disabled={!hasAccess('menu', ['write'])}
      />
      <Button onClick={() => dishSectionModal.handleOpenModal()} data-test="dish-sections">
        <FaRegListAlt />
        {t('Разделы')}
      </Button>
      <Button onClick={() => dishCategoryModal.handleOpenModal()} data-test="dish-categories">
        <FaRegListAlt />
        {t('Категории')}
      </Button>
      <HasAccess {...hasAccessProps}>
        <Button
          onClick={() =>
            navigate(
              concatPath([
                RootPath.Manager,
                ManagerPath.Menu,
                MenuPath.Informer,
                InformerPath.Import,
              ]) + buildParams({ menuId: menu?.id }),
            )
          }
          data-test="import-menu"
        >
          <MdOutlineFileUpload />
          {t('Импорт')}
        </Button>
      </HasAccess>

      <HasAccess {...hasAccessProps}>
        <Button onClick={() => createDishModal.handleOpenModal()} data-test="create-dish">
          {t('Добавить блюдо')}
        </Button>

        {/* <IconButton onClick={() => menuSettingsModal.handleOpenModal()}>
          <SettingsIcon />
        </IconButton> */}

        {/* {menuSettingsModal.isOpen && (
          <MenuInformerSettingsModal onClose={() => menuSettingsModal.handleCloseModal()} />
        )} */}
      </HasAccess>
      {dishCategoryModal.isOpen && (
        <MenuInformerCreateCategoryModal onClose={() => dishCategoryModal.handleCloseModal()} />
      )}
      {dishSectionModal.isOpen && (
        <MenuInformerCreateSectionsModal onClose={() => dishSectionModal.handleCloseModal()} />
      )}
    </div>
  );
};
